import { Reveal } from "./Reveal";
import { scrollToSection } from "@/lib/scroll";

const ConsultationCTA = () => (
    <section id="consultation" className="relative bg-[#0B192C] py-20 lg:py-24 overflow-hidden">
        <div className="absolute top-0 left-0 right-0 gold-rule" aria-hidden="true" />
        <div className="absolute bottom-0 left-0 right-0 gold-rule" aria-hidden="true" />
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
            <div className="lg:flex items-center justify-between gap-12">
                <Reveal className="max-w-xl">
                    <p className="font-mono-label text-[11px] tracking-[0.3em] uppercase text-[#DFCA9B] mb-5">
                        Schedule a Consultation
                    </p>
                    <h2 className="font-serif-display text-3xl lg:text-4xl font-medium tracking-tight text-white leading-[1.2]">
                        Discuss your legal matter in confidence
                    </h2>
                    <p className="mt-5 text-base text-white/60 leading-relaxed">
                        If you are facing a legal question or dispute, the firm invites you to get
                        in touch. Every enquiry is treated as confidential, and you will receive a
                        considered response about how the firm may be able to assist.
                    </p>
                </Reveal>
                <Reveal delay={0.15} className="mt-10 lg:mt-0 shrink-0">
                    <button
                        data-testid="consultation-cta-schedule"
                        onClick={() => scrollToSection("contact")}
                        className="bg-[#B89047] text-[#0B192C] text-sm font-semibold tracking-wide px-10 py-4 hover:bg-[#DFCA9B] transition-colors duration-300 cursor-pointer"
                    >
                        Schedule a Consultation
                    </button>
                </Reveal>
            </div>
        </div>
    </section>
);

export default ConsultationCTA;
